module.exports = __webpack_public_path__ + "static/media/MAMZN-UST.7dc2a403.svg";